import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CODE, COMP_TYPE, LOGON_INFO } from '../app.constants';
import { Code, CommonService } from '../app.service';
import { MessageService } from '../common/message.service';
import { Company, CompanyService } from '../member-kanri/company.service';
import { StateTotalService, TotalBill, TotalStatement } from './state-total.service';


import $ from 'jquery';


@Component({
    selector: 'state-total',
    templateUrl: 'state-total.component.html',
    providers: [CompanyService, StateTotalService]
})
export class StateTotalComponent implements OnInit  {

    branchList: Company[] = [];
    totalList: TotalStatement[] = [];
    compnameDaiko: string[] = [];
    compnameEtc: string[] = [];
    compCountDaiko: number = 0;
    compCountEtc: number = 0;
    dataCount: number = 0;
    // groupedBilling: TotalStatement[] = [];
    groupedBilling: {} = {};

    stateTotalList: any[] = [];
    businessIncome: TotalStatement[] = [];
    relatedIncome: TotalStatement[] = [];
    printState: TotalStatement[] = [];
    searchBranch: string;
    totalBill: TotalBill[] = [];

    today: Date;
    arrYear: number[] = Array.from({ length: 2099 - 1994 + 1 }, (_, i) => i + 1994);
    arrMonth: number[] = Array.from({ length: 12 }, (_, i) => i + 1);
    searchYear: string;
    searchMonth: string;

    stateCltrList: Code[];
    cltrCount: number = 0;
    cltrArea: string[] = [];

    constructor(
        public router: Router,
        public commonService: CommonService,
        public companyService: CompanyService,
        public messageService: MessageService,
        public totalService: StateTotalService
    ) {}

    ngOnInit() {
        this.today = new Date();
        this.searchYear = this.today.getFullYear().toString();
        this.searchMonth = (this.today.getMonth() + 1).toString();

        this.searchBranch = LOGON_INFO.COMP_ID;
        this.stateCltrList = CODE.STATE_CLTR;
        console.log('stateCltrList?!', this.stateCltrList);

        this.refreshPage();

        this.getBranchList();
    }


    /**
     * 明細リスト取得
     */
    getBillList() {
        this.totalService.getBranchTotalBill(this.searchBranch, this.searchYear, this.searchMonth)
            .subscribe(
                data => {
                    // console.log('totalBill?!', data);
                    this.totalBill = data;
                }
            )
    }

    getTotalList() {
        // this.commonService.showLoading();

        this.totalService.getBranchTotalList(this.searchBranch, this.searchYear, this.searchMonth)
            .subscribe(
                data => {
                    console.log('totalList?!', data);
                    this.stateTotalList = [];
                    let isData = false;
                    if (data.length == 0 && this.totalBill.length == 0) {
                        // 明細、請求付帯なし
                        this.dataCount = data.length;
                        this.commonService.hideLoading();

                        return;
                    } else if (data.length > 0)        isData = true;
                    let tempStateTotalList = [];
                    let dataLen = 0;
                    this.totalList = data;

                    // 大興の場合は「所属」を表示、以外は「社名」を表示
                    const filterArrayDaiko = this.totalList.filter(obj => obj.parent_comp_name === '㈱大興').map(obj => obj.comp_name);
                    const filterArrayEtc = this.totalList.filter(obj => obj.parent_comp_name !== '㈱大興').map(obj => obj.parent_comp_name);
                    this.compnameDaiko = filterArrayDaiko.filter((item, index) => filterArrayDaiko.indexOf(item) === index);
                    this.compnameEtc = filterArrayEtc.filter((item, index) => filterArrayEtc.indexOf(item) === index);
                    this.compCountDaiko = this.compnameDaiko.length;
                    this.compCountEtc = this.compnameEtc.length;

                    // 「請求先」によるグルーピング
                    this.groupedBilling = this.totalList.reduce((acc, obj) => {
                        const key = obj.billing_comp;
                        if(!acc[key]) {
                            acc[key] = [];
                        }
                        acc[key].push(obj);

                        return acc;
                    // }, []);
                    }, {});

                    const billCount = Object.keys(this.groupedBilling).length;

                    let billArray: any[] = [];
                    const filterdArray = billArray = this.totalBill.map(obj => {
                        let newObj: any = {};
                        for (let key in obj) {
                            if (obj[key] !== null)      newObj[key] = obj[key];
                        }
                        return newObj;
                    });

                    this.cltrArea = this.stateCltrList.filter(obj1 => {
                        return filterdArray.some(obj2 => obj1.extra_svalue_1 in obj2);
                    }).map(obj1 => obj1.name);
                    this.cltrCount = this.cltrArea.length;

                    let cltrFilter = this.stateCltrList.filter(obj1 => {
                        return filterdArray.some(obj2 => obj1.extra_svalue_1 in obj2);
                    }).map(obj1 => obj1.extra_svalue_1);

                    // 「得意先」によるグルーピング
                    for(let i=0; i<billCount; i++) {
                        const key = Object.keys(this.groupedBilling)[i];

                        const groupedCustomer = this.groupedBilling[key];

                        const rdcCustomer = groupedCustomer.reduce((acc, obj) => {
                            let transKey = obj.product_category == "高速代" ? "（高速代）" : "";
                            let custKey = obj.customer_comp ? obj.customer_comp + transKey : "" + transKey;
                            if(!acc[custKey]) {
                                acc[custKey] = [];
                            }
                            acc[custKey].push(obj);

                            return acc;
                        }, []);

                        // const sum = this.groupedBilling[key].reduce((acc, val) => {
                        //     if (val.parent_comp_name !== '㈱大興')       return acc + val.total_amount;
                        //     else    return acc + 0;
                        // }, 0);

                        for(let j=0; j<Object.keys(rdcCustomer).length; j++) {
                            const rdcKey = Object.keys(rdcCustomer)[j]

                            const sum = rdcCustomer[rdcKey].reduce((acc, val) => {
                                if (val.parent_comp_name !== '㈱大興')      return acc + (val.total_amount == null ? 0 : val.total_amount);
                                else                                        return acc + 0;
                            }, 0);

                            tempStateTotalList[dataLen] = [];
                            tempStateTotalList[dataLen].push(key);          //得意先（請求先）
                            tempStateTotalList[dataLen].push(rdcKey);       //得意先

                            let testArr = this.totalBill.find((b) => b.billing_comp === key && b.customer_comp === rdcKey)
                            if (testArr) {
                                tempStateTotalList[dataLen].push(testArr.billing_charge ? testArr.billing_charge : 0);              //請求額
                                tempStateTotalList[dataLen].push(testArr.collateral_import ? testArr.collateral_import : 0);        //付帯事業収入
                                cltrFilter.forEach(key => {
                                    if (testArr.hasOwnProperty(key)) {
                                        tempStateTotalList[dataLen].push(testArr[key] ? testArr[key] : 0);
                                    }
                                })      //付帯事業収入（その他）
                            }
                            else {
                                tempStateTotalList[dataLen].push(0);
                                tempStateTotalList[dataLen].push(0);
                                for (let l=0; l<this.cltrCount; l++) {
                                    tempStateTotalList[dataLen].push(0);
                                }
                            }

                            this.compnameDaiko.forEach(e => {
                                const checkArr = rdcCustomer[rdcKey].find(arr => arr.comp_name === e);
                                // if(checkArr)     tempStateTotalList[dataLen].push(checkArr.total_margin);
                                if(checkArr && checkArr.parent_comp_name === '㈱大興')     tempStateTotalList[dataLen].push(checkArr.total_margin == null ? 0 : checkArr.total_margin);
                                else tempStateTotalList[dataLen].push(0);
                            })
                            tempStateTotalList[dataLen].push(sum);       //未払運賃

                            let sundry = 0;
                            for(let k=3; k<tempStateTotalList[dataLen].length; k++) {
                                sundry += tempStateTotalList[dataLen][k];
                            }

                            if (testArr)    tempStateTotalList[dataLen].push((testArr.billing_charge ? testArr.billing_charge : 0) - sundry);       //雑収入
                            else            tempStateTotalList[dataLen].push(0 - sundry);

                            this.compnameEtc.forEach(e => {
                                const checkArr = rdcCustomer[rdcKey].find(arr => arr.parent_comp_name === e);
                                if(checkArr)     tempStateTotalList[dataLen].push(checkArr.total_amount == null ? 0 : checkArr.total_amount);
                                else tempStateTotalList[dataLen].push(0);
                            })

                            if (testArr)    billArray = billArray.filter(obj => !(obj.billing_comp === testArr.billing_comp && obj.customer_comp === testArr.customer_comp) );

                            dataLen++;
                        }

                        // this.compnameDaiko.forEach(e => {
                        //     const checkArr = this.groupedBilling[key].find(arr => arr.comp_name === e);
                        //     if(checkArr)     tempStateTotalList[i].push(checkArr.total_margin);
                        //     else tempStateTotalList[i].push(0);
                        // })

                        // tempStateTotalList[i].push(sum);       //未払運賃

                        // let sundry = 0;
                        // for(let k=2; k<tempStateTotalList[i].length; k++) {
                        //     sundry += tempStateTotalList[i][k];
                        // }

                        // tempStateTotalList[i].push(sundry);       //雑収入

                        // this.compnameEtc.forEach(e => {
                        //     const checkArr = this.groupedBilling[key].find(arr => arr.parent_comp_name === e);
                        //     if(checkArr)     tempStateTotalList[i].push(checkArr.total_amount);
                        //     else tempStateTotalList[i].push(0);
                        // })
                    }

                    console.log('billArray?!', billArray);
                    if (billArray.length > 0) {
                        for (let k=0; k<billArray.length; k++) {
                            tempStateTotalList[dataLen] = [];
                            tempStateTotalList[dataLen].push(billArray[k].billing_comp);            //得意先（請求先）
                            tempStateTotalList[dataLen].push(billArray[k].customer_comp);           //得意先
                            tempStateTotalList[dataLen].push(billArray[k].billing_charge ? billArray[k].billing_charge : 0);          //請求額
                            tempStateTotalList[dataLen].push(billArray[k].collateral_import ? billArray[k].collateral_import : 0);       //付帯事業収入

                            cltrFilter.forEach(key => {
                                if (billArray[k].hasOwnProperty(key)) {
                                    tempStateTotalList[dataLen].push(billArray[k][key] ? billArray[k][key] : 0);
                                } else      tempStateTotalList[dataLen].push(0);
                            })      //付帯事業収入（その他）

                            // 運送事業収入、運送関連収入（未払運賃、雑収入）を0で埋める
                            const cltrLen = isData ? tempStateTotalList[k].length : tempStateTotalList[k].length + 2;
                            for (let z=4+cltrFilter.length; z<cltrLen; z++) {
                                tempStateTotalList[dataLen].push(0);
                            }

                            dataLen++;
                        }
                    }
                    console.log('tempStateTotalList?!', tempStateTotalList);

                    const tempList = tempStateTotalList[0].length;

                    tempStateTotalList[dataLen] = [];
                    tempStateTotalList[dataLen].push('合計');
                    tempStateTotalList[dataLen].push('-');

                    for(let i=2; i<tempList; i++) {
                        let sum = 0;
                        for(let j=0; j<dataLen; j++) {
                            sum += tempStateTotalList[j][i];
                        }
                        tempStateTotalList[dataLen].push(sum);
                    }

                    // 全ての値が0の場合、抜く
                    this.stateTotalList = tempStateTotalList.filter(obj => {
                        let values = Object.values(obj).slice(2);
                        return !values.every(val => val === 0);
                    });
                    this.dataCount = this.stateTotalList.length - 1;

                    this.commonService.hideLoading();
                    console.log('stateTotalList?!', this.stateTotalList);
                }
            )
    }

    // async getTotalList() {
    //     await this.totalService.fetchStateTotalList();
    // }


    /**
     * 営業所リストを取得（権限は本社のみ？）
     */
    getBranchList() {
        if (LOGON_INFO.COMP_TYPE == COMP_TYPE.HEAD || LOGON_INFO.COMP_TYPE == COMP_TYPE.BRANCH) {
            this.branchList = this.companyService.getCompanyListForCombo();
        }
    }

    //画面リフレッシュ
    refreshPage(): void {
        this.commonService.showLoading();

        this.cltrCount = 0;
        this.compnameDaiko = [];

        this.getBillList();
        this.getTotalList();
    }

    stateTotalModalShow(compname: string, custname: any, position: number) {
        const isTrans = custname.search('（高速代）');
        // string.searchを使用してインデックスを検索し、custnameから（高速代）を切り出さないと検索できません！

        if (position === 0)                     return;
        if (compname === '合計')                 return;
        if (!this.groupedBilling[compname])      return;
        if (custname === '')        custname = null;
        // nullだとsliceできないため、対策を考えること！

        this.commonService.showLoading();
        this.businessIncome = [];
        this.relatedIncome = [];

        const srcCustname = (isTrans > 0) ? custname.slice(0, isTrans) : custname;
        let custArray = this.groupedBilling[compname].filter(e => e.customer_comp == srcCustname);

        if (isTrans > 0)        custArray = custArray.filter(e => e.product_category == '高速代');
        else                    custArray = custArray.filter(e => e.product_category != '高速代');

        custArray.forEach(e => {
            if (e.parent_comp_name == '㈱大興')        this.businessIncome.push(e);
            else this.relatedIncome.push(e);
        })
        $('#stateTotalModal').modal('show');

        this.commonService.hideLoading();
    }

    branchStateSearch() {
        this.refreshPage();
    }

    stateTotalExportAsExcelJs() {

        let title: any[] = [];
        const columnStyle = {
            style: { font: {size: 10, name:'メイリオ' }, alignment: { shrinkToFit: true }, border: { top: {style: 'thin'}, left: {style: 'thin'}, bottom: {style: 'thin'}, right: {style: 'thin'}} }
        };

        // title.push(
        //     { ...columnStyle, header: '請求先', key: 'index', width: 25 }
        //     , { ...columnStyle, header: '得意先', key: 'index', width: 25 }
        //     , { ...columnStyle, header: '請求額', key: 'index', width: 12 }
        //     , { ...columnStyle, header: '付帯事業収入', key: 'index', width: 12 }
        // );
        // this.cltrArea.forEach(e => title.push({ ...columnStyle, header: e, key: 'index', width: 12 }));
        // this.compnameDaiko.forEach(e => title.push({ ...columnStyle, header: e, key: 'index', width: 12 }));
        // title.push(
        //     { ...columnStyle, header: '未払運賃', key: 'index', width: 12 }
        //     , { ...columnStyle, header: '雑収入', key: 'index', width: 12 }
        // );
        // this.compnameEtc.forEach(e => title.push({ ...columnStyle, header: e, key: 'index', width: 12 }));

        title = this.cltrArea.concat(this.compnameDaiko.concat(['未払運賃', '雑収入'].concat(this.compnameEtc)));

        this.commonService.printBillTotalExcelJs(title, this.stateTotalList, this.searchYear+(this.searchMonth.length == 1 ? '0'+this.searchMonth : this.searchMonth)+'_明細合計', this.cltrCount, this.compCountDaiko);
    }

    ngOnDestroy() {
        //Modalが開いた状態でブラウザの前ページへ移動ボタン押下すると、modalは閉じられるがbackdropが消えない
        //強制的にbackdropを消す
        $(".modal-backdrop").remove();
    }
}



// WEBPACK FOOTER //
// ./src/app/statement/state-total.component.ts